
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { BitrateOptions, VgApiService } from '@videogular/ngx-videogular/core';

import { PlayerStatus } from './player.model';
import { IMediaStream } from './player.model';
import { VgHlsDirective } from '@videogular/ngx-videogular/streaming';
import * as fromPlayerSelectors from './state/player.selectors';
import * as fromPlayerActions from './state/player.actions';
import { PlayerState } from './state/player.reducer';

@Component({
  selector: 'player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit, OnDestroy {

  @ViewChild(VgHlsDirective, { static: false }) vgHls!: VgHlsDirective;

  isPlaying = false;
  isLoading = false;
  isBuffering = true;
  viewPiP = false;

  // Information we receive from the player
  api!: VgApiService;
  currentStream: IMediaStream = {type: 'hls', source: '', label: ''};
  hlsBitrates: BitrateOptions = { qualityIndex: 0, bitrate: 0, height: 0, mediaType: '', width: 0, label: ''};
  hlsSource!: string;

  element: any;
  state!: PlayerState;

  playMonitor!: Subscription;
  stopMonitor!: Subscription;
  stateMonitor!: Subscription;

  // VgMediaPlay!: Subscription;
  VGcanPlayThrough!: Subscription;

  poster = 'assets/img/loading_05.gif';

  constructor(
    public store: Store<PlayerState>,
  ) {
    // this.route.url.subscribe(c => console.log(`[route********]`, c[0].path));
  }

  ngOnInit(): void {
    // Monitor play requests
    this.playMonitor = this.store.select(fromPlayerSelectors.getPlayRequestUrl).subscribe((state) => {
      if (!state?.url) return;
      this.play(state?.url, state.PiP);

    });

    // Monitor stop requests
    this.stopMonitor = this.store.select(fromPlayerSelectors.getStopRequest).subscribe((res) => {
      if (!res) return;
      this.stop();
    });

    // Monitor active player states (not requests)
    this.stateMonitor = this.store.select(fromPlayerSelectors.getActiveStates).subscribe((state) => {
      if (!state) return;
      this.state = state;
      this.isPlaying = (state.status === PlayerStatus.Playing || state.status === PlayerStatus.Buffering);
      // TODO: add another state prop for buffer value if necessary
      // this.isBuffering = (state.status === PlayerStatus.Buffering && parseInt(state.message) < 100);

      if (this.isPlaying && !this.isBuffering) this.isLoading = false;

      console.log(`[Player][State] i(${state.instances}), s(${PlayerStatus[state.status]}), m(${state.message})`);
    });
  }

  ngOnDestroy(): void {
    if (this.playMonitor) this.playMonitor.unsubscribe();
    if (this.stopMonitor) this.stopMonitor.unsubscribe();
    if (this.stateMonitor) this.stateMonitor.unsubscribe();
  }

  onPlayerReady(api: VgApiService): void {
    this.api = api;

    // pause
    this.api.getDefaultMedia().subscriptions.pause.subscribe(
      () => {
        // console.log('-- Pause state*******************', this.api.getDefaultMedia().state);
        this.api.play();
        this.isBuffering = this.api.getDefaultMedia().canPlay
      }
    )
    // error
    this.api.getDefaultMedia().subscriptions.error.subscribe(
      () => {
        console.log('-- ERROR state********************', this.api.getDefaultMedia().state);
      }
    )

    // canPlayThrough
    this.VGcanPlayThrough = this.api.getDefaultMedia().subscriptions.canPlayThrough.subscribe(
      () => {
        if(this.api.getDefaultMedia().state == 'paused'){
          this.isBuffering = this.api.getDefaultMedia().canPlay;
          this.api.play();
        }

      }
    )

    this.store.dispatch(fromPlayerActions.PlayerReady());
  }

  play(url: string, PiP: boolean): void {
    this.isBuffering = false
    if (!this.checkConditions()) return;
    // this.api.pause();
    this.isLoading = true;
    this.viewPiP = PiP;
    // reset player if needed
    // switch (this.state.status) {
    //   case PlayerStatus.Playing:
    //     this.stop();
    //     break;
    // }
    // check if we still need it after first player works
    // this.hlsSource = url;
    this.currentStream = {
      type: 'hls',
      source: url,
      label: url
    };
    // this.api.play();
    console.log('is playing');
    // this.isPlaying = true;
    // console.log(`[Player][Play] instance PLAY called ${url}`);
    this.store.dispatch(fromPlayerActions.PlayerPlaying({url, message: 'everything is fine'}));
  }

  stop(pause: boolean = true): void {
    if (!this.checkConditions()) return;
    console.log(`[Player][Play] instance STOP called`);
    this.currentStream = {
      type: 'hls',
      source: '',
      label: ''
    };
    this.api.pause();
    this.isPlaying = false;
    this.viewPiP = false;
    this.store.dispatch(fromPlayerActions.PlayerStopped());
  }

  sourceBitrates(event: any) {
    this.hlsBitrates = event;
  }

  private checkConditions(): boolean {
    if (!this.api) {
      // this.store.dispatch({ type: PLAYER_ERROR, payload: 'No video w/o DOM' });
      return false;
    }
    return true;
  }
}
